import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Websites {
    constructor() {
        if (document.getElementById('websites') !== null) {
            this.logos();
            this.whatWeDo();
        }
    }

    logos() {


        setInterval(() => {
            initLogosAnimation();
        }, 1500)


        function initLogosAnimation() {
            let existImages = [];

            document.querySelectorAll('.partners img').forEach((img) => {
                let matches = img.src.match(/img\/website-partners\/(.+)/);

                existImages.push(matches[1]);
            });

            const items = document.querySelectorAll('.partners .item');

            const randomItem = Math.floor(Math.random() * items.length);
            const item = items[randomItem];


            const imageArray = JSON.parse(document.querySelector('#partner-logos').textContent);
            let src = imageArray[Math.floor(Math.random() * imageArray.length)];

            while (existImages.includes(src)) {
                src = imageArray[Math.floor(Math.random() * imageArray.length)]
            }

            const img = document.createElement("img");

            const allImages = item.querySelectorAll('img');
            const randomImage = Math.floor(Math.random() * allImages.length);

            const selectedImage = allImages[randomImage];

            img.classList.add('custom-reveal', 'left');
            img.src = "/img/website-partners/" + src;

            selectedImage.style.transform = 'translateX(100px)'
            selectedImage.style.opacity = 0;


            window.setTimeout(() => {
                if (randomImage === 0 && allImages.length > 1) {
                    item.prepend(img);
                } else {
                    item.append(img);
                }

                selectedImage.remove();

                window.setTimeout(() => {
                    img.classList.add('load');
                }, 400)
            }, 400)
        }
    }

    whatWeDo() {
        if (document.querySelector('#whatWeDo')) {
            const swiper = new Swiper('#whatWeDo .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                pagination: {
                    el: '#whatWeDo .swiper-pagination',
                    type: 'bullets',
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.5,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    }
                }
            });
        }
    }
}
